<template>
  <div class="info-content">
    <div class="course-box">
      <div class="course-menu">
        <div class="course-class">
          <div class="name">资讯分类：</div>
          <span
            v-for="(item,index) in res"
            :key="item.id"
            :class="zero_flag==index?'active':''"
            @click="toGetNewsList(item.id,index)"
          >{{item.title}}</span>
        </div>
      </div>
      <div class="info-list">
        <div class="info-box" v-for="(items, i) in newsLists" :key="i" @click="toInfoDes(items.id,items.kind_id)">
          <div class="info-card">
            <div class="info-cover">
              <img :src="items.img_url" alt />
            </div>
            <div class="info-details">
              <div class="title">{{items.title}}</div>
              <div class="neiron">{{items.brief}}</div>
              <div class="time">{{items.create_time | dateformat('YYYY-MM-DD')}} <span><img src="@img/eye.png" alt>{{items.viewer_num}}</span></div>
            </div>
          </div>
        </div>
        <div v-show="showNews">
          <div class="noData">该分类下暂无数据</div>
        </div>
        
      </div>
      <div class="page">
        <a-pagination
          :defaultCurrent="1"
          :size="'small'"
          :current="current"
          :defaultPageSize="10"
          :total="total_num"
          @change="onChange"
        />
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { getCookie, group_sign } from '../../utils/tool'
export default {
  name: 'Info',
  data() {
    return {
      res: [],
      zero_flag: 0,
      newsList: [],
      topId:Number(getCookie('top_category_id')),
      account_id:Number(getCookie('account_id')),
      showNews: false,
      total_num: 0,
      current: 1,
      page_size:10,
      page:1
    };
  },
  watch: {
    current(val) {
      // console.log('current',val)
      // console.log("消失了");
      this.$nextTick(() => {
        // console.log("出现了");
        for (let i in this.res) {
          if(Number(i) == this.zero_flag) {
            this.getNewsList(this.res[i].id)
          }
        }
      });
    }
  },
  computed: {
    newsLists: function() {
      return this.sortKey(this.newsList,'order_num')
    }
  },
  methods: {
    sortKey(arr, key){
      return arr.sort(function(a, b){
        var x = a[key];
        var y = b[key];
        return ((x<y)?-1:(x>y)?1:0)
      })
    },
    getNewsKind() {
      let that = this;
      var param = group_sign({})
      this.$axios.post(this.$Api.apiGetNewsKindList, param).then(
        res => {
          that.res = res.data.result.list;
          if (that.res) {
            // that.res.unshift({
            //     name: "全部",
            //     id: 0,
            //     order_num: -100
            // })
          }
          that.getNewsList(that.res[0].id)
        }
      ).catch(error => {console.log(error, ">>>>>>>>>");});
    },
    onChange(current) {
      this.current = current;
      this.page = current
      this.getNewsList()      
    },
    getNewsList(category_id) {
      let that = this;
      var params = group_sign({page_size: this.page_size, page:this.page, visible: "1", category_id:category_id })
      this.$axios.post(this.$Api.apiGetNewsAll, params).then(
        res => {
          that.newsList = res.data.result.list;
          that.total_num = res.data.result.total
          if (that.newsList.length > 0) {
            that.showNews = false
          } else {
            that.showNews = true
          }
        }
      ).catch(error => {console.log(error, ">>>>>>>>>");});
    },
    toGetNewsList(id, index) {
      this.zero_flag = index;
      this.newsList = [];
      this.getNewsList(id);
    },
    toInfoDes(id,kind_id) {
      this.$router.push({
        path: "/page/info_details",
        query: { id: id,kind_id: kind_id }
      });
    }
  },
  beforeMount() {
    this.getNewsKind();
  }
};
</script>
<style lang="less" scoped>
.info-content {
  min-height: 1180px;
  width: 100%;
  height: 100%;
  padding-top: 25px;
  padding-bottom: 30px;
  background: rgb(248, 249, 250);
  .info-list {
      border: 1px solid #E2E2E2;
      border-radius: 4px;
      padding: 0 25px;
      background: #fff;
      margin-top: 20px;
      .info-box {
        display: inline-block;
        // width: 50%;
        cursor: pointer;
        box-sizing: border-box;
        padding: 25px 15px 21px 13px;
        border-top: 1px solid #E2E2E2;
        &:first-child{
          border-top: 0
        }
        .info-card {
          width: 1084px;
          display: flex;
          flex-direction: row;
          box-sizing: border-box;
          background: #fff;
          // border: 1px solid #ebebeb;
          // padding: 16px;
          transition: 0.3s ease all;
          border-radius: 4px;
          // &:hover {
          //   transform: translateY(-6px);
          //   -webkit-transform: translateY(-6px);
          //   -moz-transform: translateY(-6px);
          //   box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
          //   -webkit-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
          //   -moz-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
          // }
          .info-cover {
            flex: 1;
            box-sizing: border-box;
            padding-right: 15px;
            img {
              width: 232px;
              height: 135px;
              border-radius: 4px
            }
          }
          .info-details {
            flex: 4;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-left: 10px;
            .title {
              font-family: 'MicrosoftYaHeiUI';
              font-size: 18px;
              color: #333333;
              letter-spacing: 0;
              &:hover {
                color:#3B9DFF
              }
            }
            .neiron {
              font-family: "MicrosoftYaHeiUI";
              font-size: 14px;
              color: #999999;
              letter-spacing: 0;
              line-height: 26px;
            }
            .time {
              font-family: 'MicrosoftYaHeiUI';
              font-size: 14px;
              color: #999999;
              letter-spacing: 0;
              span {
                margin-left: 38px;
                img{
                  width: 14px;
                  height: 15px;
                  margin-top: -2px;
                  margin-right: 10px;
                }
              }
            }
          }
        }
      }
      .noData {
        text-align: center;
        /* margin-top: 20px; */
        background: #fff;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
      }
      
    }
    .page {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
        :global(.ant-pagination li) {
          min-width: 5px;
        }
        :global(.ant-pagination li a) {
          font-size: 12px;
        }
        :global(.ant-pagination li span) {
          font-size: 12px;
        }
      }
  .course-box {
    box-sizing: border-box;
    margin: 0 auto;
    width: 1180px;
    padding: 0 15px;
    .course-menu {
      background: #fff;
      box-sizing: border-box;
      width: 100%;
      padding: 0 25px;
      padding-top: 20px;
      border: 1px solid #ebebeb;
      .course-class {
        width: 100%;
        box-sizing: border-box;
        line-height: 60px;
        min-height: 60px;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        align-items: center;
        text-align: center;
        .name{
          min-width: 70px;
          height: 25px;
          line-height: 25px;
          margin-bottom: 10px;
        }
        span {
          cursor: pointer;
          height: 25px;
          min-width: 70px;
          padding: 0 5px 0 5px;
          line-height: 25px;
          margin-left: 35px;
          margin-bottom: 10px;
        }
        .active {
          background: #3b9dff;
          color: #fff;
          border-radius: 2px;
        }
      }
    }
  }
}
</style>
